// ============================================================
// SaveModal.jsx — "Save as new copy" vs "Replace original"
// ------------------------------------------------------------
// Shown when the user clicks Save to Library. Two card-style choices plus
// cancel. In batch mode the same choice applies uniformly to every photo.
// ============================================================

import React from 'react';

export default function SaveModal({ open, busy, batchCount = 0, onChoose, onClose }) {
  if (!open) return null;
  const isBatch = batchCount > 1;

  return (
    <div className="pe-modal-backdrop" onClick={busy ? undefined : onClose}>
      <div className="pe-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pe-modal-title">
          {isBatch ? `Save ${batchCount} edited photos` : 'Save edited photo'}
        </div>
        <div className="pe-modal-sub">
          {isBatch
            ? 'Your choice applies to all selected photos.'
            : 'Keep the original or replace it?'}
        </div>

        <div className="pe-modal-cards">
          <button
            className="pe-savecard"
            disabled={busy}
            onClick={() => onChoose('new')}
          >
            <span className="pe-savecard-icon">＋</span>
            <span className="pe-savecard-title">Save as new copy</span>
            <span className="pe-savecard-desc">Original stays untouched</span>
          </button>
          <button
            className="pe-savecard"
            disabled={busy}
            onClick={() => onChoose('overwrite')}
          >
            <span className="pe-savecard-icon">⤺</span>
            <span className="pe-savecard-title">Replace original</span>
            <span className="pe-savecard-desc">Overwrites the existing photo</span>
          </button>
        </div>

        <div className="pe-modal-foot">
          <button className="pe-btn pe-btn-ghost" disabled={busy} onClick={onClose}>
            Cancel
          </button>
          {busy && <span className="pe-modal-busy">Saving…</span>}
        </div>
      </div>
    </div>
  );
}
